export const GET_DIMENSIONS_WATCHER =
  "app/WidgetResultByDimensionTeam/GET_DIMENSIONS_WATCHER"
export const GET_DIMENSIONS_SUCCESS =
  "app/WidgetResultByDimensionTeam/GET_DIMENSIONS_SUCCESS"
export const GET_DIMENSIONS_FAILED =
  "app/WidgetResultByDimensionTeam/GET_DIMENSIONS_FAILED"
